module.exports = __webpack_public_path__ + "static/media/Circo2024_28.a56afad0.webp";